module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMi4zMDgiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMi4zMDggMTYiPgogIDxwYXRoIGlkPSJJY29uX2lvbmljLW1kLWRvY3VtZW50IiBkYXRhLW5hbWU9Ikljb24gaW9uaWMtbWQtZG9jdW1lbnQiIGQ9Ik0xNC4xMzUsMy4zNzVIOC4yODhBMS41MzgsMS41MzgsMCwwLDAsNi43NSw0LjkxM1YxNy44MzdhMS41MzgsMS41MzgsMCwwLDAsMS41MzgsMS41MzhoOS4yMzFhMS41MzgsMS41MzgsMCwwLDAsMS41MzgtMS41MzhWOC4zWm0tLjYxNSw1LjUzOFY0LjYwNmw0LjMwOCw0LjMwOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02Ljc1IC0zLjM3NSkiIGZpbGw9IiNmZmYiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico_doc.svg
// module id = 1BNe
// module chunks = 1